// extracted by mini-css-extract-plugin
export default {"root":"AvailableSolutions_root__QyIpZ","solutionCardContainer":"AvailableSolutions_solutionCardContainer__B+4U4"};